<template>
<el-scrollbar class="page-scroll">
  <div style="width: 100%; height: 100%">
  <el-container class="container">
    <!-- <el-scrollbar class="page-scroll"> -->
    <el-row class="login-main" :style="{width: loginMain.w + 'px', height: loginMain.h + 'px'}">
      <el-col id="lg-col-1">
        <div class="title">{{$t('login.platform')}}</div>
        <div class="col1-bg1v-icons">
          <img id="lg-img22" class="login-img22" src="/static/images/login/login_icon_22.png" />
          <!-- <img id="lg-img3" src="/static/images/login/login_icon_3.png" />
          <img id="lg-img4" src="/static/images/login/login_icon_4.png" /> -->
        </div>
        <!-- <div class="col1-bg2v-icons">
          <img id="lg-img3" src="/static/images/login/login_icon_3.png" />
          <img id="lg-img4" src="/static/images/login/login_icon_4.png" />
        </div> -->
        <div class="col1-bg2v-icons">
          <img id="lg-img3" src="/static/images/login/login_icon_3.png" />
          <img id="lg-img4" src="/static/images/login/login_icon_4.png" />
          <img id="lg-img20" src="/static/images/login/login_icon_20.png" />
          <img id="lg-img21" src="/static/images/login/login_icon_21.png" />
          <img id="lg-img12" src="/static/images/login/login_icon_12.png" />
          <img id="lg-img14" src="/static/images/login/login_icon_14.png" />
          <img id="lg-img15" src="/static/images/login/login_icon_15.png" />
          <img id="lg-img17" src="/static/images/login/login_icon_17.png" />
          <img id="lg-img16" src="/static/images/login/login_icon_16.png" />
          <img id="lg-img19" src="/static/images/login/login_icon_19.png" />
          <img id="lg-img13" src="/static/images/login/login_icon_13.png" />
          <img id="lg-img18" src="/static/images/login/login_icon_18.png" />
          <!-- <img id="lg-bgl" src="/static/images/background_left.png" /> -->
        </div>
        <!-- <div class="col1-line-icons">
          <img id="lg-img20" src="/static/images/login/login_icon_20.png" />
          <img id="lg-img21" src="/static/images/login/login_icon_21.png" />
        </div> -->
      </el-col>
      <el-col id="lg-col-2">
        <!-- <div class="lg-caret">
          <img id="lg-img25" src="/static/images/login/login_icon_25.png" />
        </div> -->
        <!-- <div class="login-line"> -->
          <!-- <div class="login-dot left-dot"></div> -->
          <img id="lg-img26" src="/static/images/login/login_icon_26.png" />
          <img id="lg-img27" src="/static/images/login/login_icon_27.png" />
        <!-- </div> -->
        <!-- <div class="login-line right-line">
          <div class="login-dot right-dot"></div>
        </div> -->
      </el-col>
      <!-- <el-col>
      </el-col> -->
      <el-col id="lg-col-3">
        <div class="login-wrap">
          <el-row type="flex" justify="center" align="middle" class="lg-logo">
            <img :src="$t('login.logoSrc')" :title="$t('login.company')" />
          </el-row>
          <transition name="slide-fade" mode="out-in">
            <el-form v-if="isLoginForm" :model="loginForm" :rules="rules" ref="loginForm" class="login" key="loginForm">
              <el-form-item prop="username" class="input-item-wrap">
                <el-input type="text" v-model.trim="loginForm.username" class="input-item" :placeholder="$t('login.account')" maxlength="20" @keypress.13.native="login('loginForm')">
                  <i slot="suffix" class="clear" @click="clear(loginForm, 'username')"></i>
                </el-input>
              </el-form-item>
              <el-form-item prop="password" class="input-item-wrap">
                <el-input :type="visiable?'text':'password'" v-model="loginForm.password" class="input-item" :placeholder="$t('login.password')" maxlength="20" @keypress.13.native="login('loginForm')">
                  <i slot="suffix" :class="{open: visiable, close: !visiable}" @click="openEye"></i>
                  <i slot="suffix" class="clear" @click="clear(loginForm, 'password')"></i>
                </el-input>
              </el-form-item>
              <el-form-item class="submit">
                <el-button class="login-btn" @click="login('loginForm')" :disabled="requestings.logining">{{requestings.logining ? $t('login.logining') : $t('login.login')}}</el-button>
                <div class="el-form-item__error err" v-show="loginErr">{{errMessage}}</div>
              </el-form-item>
            </el-form>
            <el-form v-else :model="sysForm" :rules="sysRules" ref="sysForm" class="login" label-position="top" key="sysForm">
              <!-- <el-form-item :label="$t('login.chooseSysType')" prop="sysType" class="input-item-wrap"> -->
              <el-form-item prop="sysType" class="input-item-wrap">
                  <!-- <el-select class="input-item" v-model="sysForm.sysType" @change="chooseSys" popper-class="login-select"> -->
                  <el-select class="input-item" v-model="sysForm.sysType" @change="chooseSys" :placeholder="$t('login.chooseSysType')" :title="sysForm.sysType ? sysForm.sysType.label : $t('login.chooseSysType')" popper-class="login-select">
                    <el-option v-for="(item, index) in sysTypeOpts" :key="index" :label='item.label' :value="item" @click.native="editLabel"></el-option>
                    <!-- <el-option v-for="(item, index) in sysTypeCustom" :key="index + 3" :label='item.label' :value="item"></el-option> -->
                  </el-select>
              </el-form-item>
              <p class="login-tips">{{$t('login.sysTips')}}</p>
              <!-- <p id="custom-label"><el-button id="edit-label" type="text" @click="editLabel">{{$t('login.customLabel') + '?'}}</el-button></p> -->
              <el-form-item class="submit">
                <el-button class="login-btn" @click="sure('sysForm')" :disabled="requestings.sureSencing">{{requestings.sureSencing ? $t('login.submiting') : $t('login.sure')}}</el-button>
                <div class="el-form-item__error err" v-show="chooseErr">{{chooseErrMsg}}</div>
              </el-form-item>
            </el-form>
          </transition>
        </div>
        <div class="col2-bg1v-icons">
          <img id="lg-img23" src="/static/images/login/login_icon_23.png" />
        </div>
      </el-col>
      <div class="bgTop-icons">
        <img id="lg-img5" src="/static/images/login/login_icon_5.png" />
        <img id="lg-img6" src="/static/images/login/login_icon_6.png" />
      </div>
    </el-row>
    <div class="bg1v-icons">
      <img id="lg-img1" src="/static/images/login/login_icon_1.png" />
      <img id="lg-img9" src="/static/images/login/login_icon_9.png" />
      <img id="lg-img8" src="/static/images/login/login_icon_8.png" />
      <img id="lg-img24" src="/static/images/login/login_icon_24.png" />
      <img id="lg-img10" src="/static/images/login/login_icon_10.png" />
      <img id="lg-img11" src="/static/images/login/login_icon_11.png" />
      <img id="lg-img7" src="/static/images/login/login_icon_7.png" />
    </div>

    <custom-dialog class="label-edit-dialog" :dialog-title="dialogTitle" dialog-width="74%" :dialog-visible="labelEditDialog" @dialog-close="cancelDialog">
      <!-- <section>
        <h4>场景名编辑</h4>
        <el-form v-if="scenarioReset" :model="scenarioForm" :rules="scenarioRules" ref="scenarioForm" label-width="122px" label-position="right">
          <el-form-item><el-form-item>
        </el-form>
      </section>
      <section>
        <h4>字段编辑</h4> -->
        <!-- <el-form v-if="labelEditReset" :model="labelEditForm" :rules="labelEditRules" ref="labelEditForm" label-width="122px" label-position="right"> -->
          <el-collapse v-model="activeNames" @change="handleChange" v-loading="labelEditLoading" id="label-edit-collapse">
            <el-collapse-item :title="$t('login.sence.edit')" name="sence">
              <el-form v-if="senceEditReset" :model="senceEditForm" :rules="senceEditRules" ref="senceEditForm" label-width="165px" label-position="right">
                <el-form-item prop="sence" :label="$t('login.sence.name')">
                  <el-input v-model.trim="senceEditForm.sence" clearable maxlength="13" disabled></el-input>
                </el-form-item>
                <el-form-item prop="senceLang" :label="$t('login.sence.labelLang')">
                  <el-checkbox-group v-model="senceEditForm.senceLang" id="sence-lang">
                    <el-checkbox v-for="item in senceLangOpt" :key="item.langVal" :label="item.langVal" name="senceLang">{{item.langLabel}}</el-checkbox>
                    <!-- <el-checkbox label="en" name="senceLang">英文</el-checkbox> -->
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-collapse-item>
            <!-- <el-collapse-item v-if="senceEditForm.senceLang.indexOf('zh') !== -1" title="中文字段编辑" name="2">
              <el-form v-if="labelEditReset.zh" :model="labelEditForm.zh" :rules="labelEditRules.zh" ref="labelEditFormZh" label-width="122px" label-position="right">
                <el-form-item class="label-input" v-for="(item, key) in labels" :key="key" :prop="key" :label="labelEditLabel[key].label">
                  <el-input v-model.trim="labelEditForm.zh[key]" clearable maxlength="13"></el-input>
                </el-form-item>
              </el-form>
            </el-collapse-item> -->
            <template v-for="item in senceLangOpt">
              <el-collapse-item :key="item.langVal" v-if="senceEditForm.senceLang.indexOf(item.langVal) !== -1" :title="item.editTitle" :name="item.langVal" >
                <el-form v-if="labelEditReset[item.langVal]" :model="labelEditForm[item.langVal]" :rules="labelEditRules[item.langVal]" :ref="'labelEditForm' + item.langVal" label-width="122px" label-position="right">
                  <el-form-item class="label-input" v-for="item1 in labels" :key="item1.prop" :prop="item1.prop" :label="labelEditLabel[item1.prop][item.langVal].label">
                    <el-input v-model.trim="labelEditForm[item.langVal][item1.prop]" clearable maxlength="15" :disabled="!item1.editable || sysForm.sysType.value !== 'custom'"></el-input>
                  </el-form-item>
                </el-form>
                <!-- <div class="dialog-footer">
                  <el-button type="primary" @click="labelEditSure">{{$t('login.sure')}}</el-button>
                </div> -->
              </el-collapse-item>
            </template>
          </el-collapse>
          <!-- <h4>场景名编辑</h4>
          <el-form-item prop="sence" label="场景">
            <el-input v-model.trim="labelEditForm.sence" clearable maxlength="13"></el-input>
          </el-form-item>
          <h4>字段编辑</h4>
          <el-form-item v-for="(item, key) in labelEditLabel" :key="key" :prop="key" :label="item">
            <el-input v-model.trim="labelEditForm[key]" clearable maxlength="13"></el-input>
          </el-form-item> -->
        <!-- </el-form> -->
      <!-- </section> -->
      <div slot="footer" class="dialog-footer">
        <template v-if="!requestings.postSencing">
          <el-button @click="cancelDialog">{{$t('login.cancel')}}</el-button>
          <!-- <el-button type="primary" @click="labelEditSure" :disabled="sysForm.sysType.value !== 'custom'">{{$t('login.sure')}}</el-button> -->
          <el-button v-if="sysForm.sysType.value !== 'custom'" type="primary" @click="cancelDialog">{{$t('login.sure')}}</el-button>
          <el-button v-else type="primary" @click="labelEditSure">{{$t('login.sure')}}</el-button>
        </template>
        <template v-else>
          <el-button type="primary" disabled>{{$t('login.submiting')}}</el-button>
        </template>
        <!-- <el-button @click="cancelDialog">{{$t('login.cancel')}}</el-button>
        <el-button v-if="sysForm.sysType.value !== 'custom'" type="primary" @click="cancelDialog">{{$t('login.sure')}}</el-button>
        <el-button v-else type="primary" @click="labelEditSure" :disabled="requestings.postSencing">{{requestings.postSencing ? $t('login.submiting') : $t('login.sure')}}</el-button> -->
      </div>
    </custom-dialog>


    <custom-dialog dialog-width="15%" :dialog-visible="msg1Dialog" @dialog-close="cancelMsg">
    <!-- <custom-dialog :dialog-title="dialogTitle" :dialog-visible="msgDialog" @dialog-close="dialogClose"> -->
      <span class="msg">{{operateMsg}}</span>
      <div slot="footer" class="dialog-footer one-btn">
        <el-button type="primary" @click="cancelMsg">{{$t('login.sure')}}</el-button>
      </div>
    </custom-dialog>
    <!-- <div class="bgTop-icons">
      <img id="lg-img5" src="/static/images/login/login_icon_5.png" />
      <img id="lg-img6" src="/static/images/login/login_icon_6.png" />
    </div> -->
      <!-- <el-row class="login-main">
        <el-col class="left">
          <el-row class="title">{{$t('login.platform')}}</el-row>
        </el-col>
        <el-col class="right">
          <el-row type="flex" justify="center" align="middle">
            <img src="/static/images/logo.png" :title="$t('login.company')" />
          </el-row>
          <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login">
            <el-form-item prop="username" class="input-item-wrap">
              <el-input type="text" v-model.trim="loginForm.username" class="input-item" :placeholder="$t('login.account')" maxlength="20" @keypress.13.native="login('loginForm')">
                <i slot="suffix" class="clear" @click="clear(loginForm, 'username')"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password" class="input-item-wrap">
              <el-input :type="visiable?'text':'password'" v-model="loginForm.password" class="input-item" :placeholder="$t('login.password')" maxlength="20" @keypress.13.native="login('loginForm')">
                <i slot="suffix" :class="{open: visiable, close: !visiable}" @click="openEye"></i>
                <i slot="suffix" class="clear" @click="clear(loginForm, 'password')"></i>
              </el-input>
            </el-form-item>
            <el-form-item class="submit">
              <el-button class="login-btn" @click="login('loginForm')">{{$t('login.login')}}</el-button>
              <div class="el-form-item__error err" v-show="loginErr">{{errMessage}}</div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row> -->
    <!-- </el-scrollbar> -->
  </el-container>
  </div>
</el-scrollbar>
</template>

<script>
// import Vue from 'vue'
import authToken from '../common/authToken'
import customDialog from "../common/dialog.vue"
import objOperate from '../common/objOperate'
export default {
  components: {
    customDialog
  },
  data () {
    var validPass = (rule, value, callback) => {
      if(/[\u4E00-\u9FA5]/g.test(value)) {
        callback(new Error())
      } else {
        callback()
      }
    }

    // var validSence = (rule, value, callback) => {
    //   var vm = this
    //   if(!value) {
    //     callback(new Error(this.$t('login.labelEditValidMsg.sence')))
    //   } else {
    //     this.axios({
    //       method: 'get',
    //       url:'/V1/sence/check?sence=' + vm.senceEditForm.sence,
    //       headers:{
    //         'Authorization': 'Bearer ' + authToken.getToken()
    //       }
    //     }).then(function(res){
    //       //console.log(res)
    //       if(res.data.errcode == 10000701){
    //         callback(new Error(vm.$t('login.labelEditValidMsg.senceExist')))
    //       } else {
    //         callback()
    //       }
    //     }).catch(function(err){
    //       //console.log(err)
    //       if(err.response && err.response.status == 401){
    //         vm.$router.push('/')
    //         authToken.removeUserInfo()
    //       } else {
    //         callback(new Error(vm.$t('login.labelEditValidMsg.senceFail')))
    //       }
    //     })
    //   }
    // }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      visiable: false,
      loginErr: false,
      errMessage: this.$t('login.loginTip.exist'),
      isLoginForm: true,
      rules: {
        username: [
          {required: true, message: this.$t('login.validMsg.userName'), trigger: 'change'},
          {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        ],
        password:[
          {required: true, message: this.$t('login.validMsg.password'), trigger: 'change'},
          { min: 6, max: 20, message: this.$t('login.validMsg.length1'), trigger: 'change' },
          {pattern: /^\S+$/, message: this.$t('login.validMsg.passRule'), trigger: 'change'},
          {validator: validPass, message: this.$t('login.validMsg.passRule1'), trigger: 'change'}
        ]
      },
      sysTypeOpts: this.$t('login.sysTypeOpts'),
      // sysTypeCustom: [{
      //   label: 'aa',
      //   value: 'aa'
      // }, {
      //   label: 'bb',
      //   value: 'bb'
      // }],
      sysForm: {
        // sysType: this.$t('login.sysTypeOpts')[0].value
        sysType: ''
      },
      sysRules: {
        sysType: [
          {required: true, message: this.$t('login.chooseSysType'), trigger: 'change'}
        ],
      },
      chooseErr: false,
      chooseErrMsg: '',
      // isRootRole: false,
      token: '',
      // storeId: ''
      dialogTitle: '',
      labelEditDialog: false,
      labelEditReset: {
        zh: true,
        en: true,
        ja: true
      },
      senceEditReset: true,
      labels: this.$labels,
      labelEditForm: {
        zh: {},
        en: {},
        ja: {}
      },
      senceLangOpt: this.$t('login.senceLang'),
      senceEditForm:{
        sence: '',
        senceLang: []
      },
      labelEditLabel: this.$t('login.labelEditLabel'),
      labelEditRules: {
        zh: {
          // label1: [
          //   {required: true, message: this.$t('login.labelEditValidMsg["label1"]'), trigger: 'change'},
          //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
          // ]
        },
        en: {
          // label1: [
          //   {required: true, message: this.$t('login.labelEditValidMsg["label1"]'), trigger: 'change'},
          //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
          // ]
        },
        ja: {

        }
        // label1: [
        //   {required: true, message: this.$t('login.labelEditValidMsg["label1"]'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label2: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label2'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label3: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label3'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label4: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label4'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label5: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label5'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label6: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label6'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label7: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label7'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label8: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label8'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label9: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label9'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label10: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label10'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label11: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label11'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label12: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label12'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label13: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label13'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label14: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label14'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label15: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label15'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label16: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label16'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label17: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label17'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label18: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label18'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label19: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label19'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ],
        // label20: [
        //   {required: true, message: this.$t('login.labelEditValidMsg.label20'), trigger: 'change'},
        //   // {pattern: /^[a-zA-Z0-9]+$/, message: this.$t('login.validMsg.userNameRule'), trigger: 'change'}
        // ]
      },
      senceEditRules: {
        sence: [
          {required: true, message: this.$t('login.labelEditValidMsg.sence'), trigger: 'change'},
          // {validator: validSence, trigger: 'blur'}
        ],
        senceLang: [
          // {required: true, message: this.$t('login.labelEditValidMsg.senceLang'), trigger: 'change'},
        ]
      },
      activeNames: ['sence'],
      labelEditLoading: false,
      msg1Dialog: false,
      operateMsg: '',
      cancelToken:null,
      source:null,
      requestings: {
        logining: false,
        sureSencing: false,
        postSencing: false
      },
      loginMain: {
        w: 1920 * 88.125 / 100,
        h: 937 * 79 / 100
      }
    }
  },
  mounted(){
    // this.$refs.loginForm.resetFields() //兼容ie
    // objOperate.copyObjT2O(this.labelEditForm.zh, this.labels)
    // objOperate.copyObjT2O(this.labelEditForm.en, this.labels)

    // for(var i in this.labels){
    //   this.$set(this.labelEditForm.zh, i, this.labels[i])
    //   this.$set(this.labelEditRules.zh, i, [{required: true, message: this.$t('login.labelEditValidMsg["' + i + '"]'), trigger: 'change'}])
    //   this.$set(this.labelEditForm.en, i, this.labels[i])
    //   this.$set(this.labelEditRules.en, i, [{required: true, message: this.$t('login.labelEditValidMsg["' + i + '"]'), trigger: 'change'}])
    // }
    var vm = this
    for(var i in this.labelEditForm) {
      for(var j = 0; j < this.labels.length; j++) {
        var prop = this.labels[j].prop
        this.$set(this.labelEditForm[i], prop, '')
        this.$set(this.labelEditRules[i], prop, [{required: true, message: this.$t('login.labelEditValidMsg.input', {name: this.labelEditLabel[prop][i].label}), trigger: 'change'}])
      }
    }
    this.loginCompat()
    window.onresize = function() {
      vm.loginCompat()
    }
    // console.log(this.labelEditRules)
  },
  destroyed(){
    // console.log('overview destroyed')
    window.onresize = null
  },
  methods: {
    loginCompat: function() {
      // console.log('loginCompat', window.innerWidth, window.innerHeight)
      var w = window.innerWidth * 88.125 / 100
      var h = window.innerHeight * 79 / 100
      var initW = 1920 * 88.125 / 100
      var initH = 937 * 79 / 100
      if(window.innerWidth < 1344) {
        w = 1344 * 88.125 / 100
      }
      if(window.innerHeight < 650) {
        h = 650 * 79 / 100
      }
      if(initH * w / initW > h) {
        this.loginMain.w = Math.floor(h * initW / initH)
        this.loginMain.h = Math.floor(h)
      } else {
        this.loginMain.w = Math.floor(w)
        this.loginMain.h = Math.floor(initH * w / initW)
      }
    },
    clear: function (form, attr) {
      form[attr] = ''
    },
    openEye: function () {
      this.visiable = !this.visiable
    },
    login: function (form) {
      var vm = this
      this.$refs[form].validate((valid) => {
        if (valid) {
          vm.requestings.logining = true
          vm.axios({
            method: 'post',
            url: '/V1/pc/Login',
            data: {
              username: vm.loginForm.username,
              // password: vm.loginForm.password
              password: vm.$md5(vm.loginForm.password)
            }
          }).then(function (res) {
            // console.log(res)
            if(res.data.errcode===200){
              vm.token = res.data.body.token
              vm.axios({
                method: 'get',
                url: '/V1/userInfo',
                headers:{
                  'Authorization': 'Bearer ' + vm.token
                }
              }).then(function (resp) {
                // console.log(resp)
                var isRootRole = false
                // var hasStores = userRoles.length === 0 ? false : true
                var userRoles = resp.data.body.roles
                for(var i = 0; i < userRoles.length; i++) {
                  if(userRoles[i].rname === 'root') {
                    isRootRole = true
                    break
                  }
                }
                if(res.data.body.first) {
                  if(isRootRole) {
                    vm.isLoginForm = false
                  } else {
                    vm.loginErr = true
                    vm.errMessage = vm.$t('login.loginTip.chooseSys')
                  }
                  vm.requestings.logining = false
                } else {
                  vm.requestings.logining = false
                  // vm.$route.meta.isLogin = true
                  authToken.storeUserInfo({token: vm.token})
                  vm.$router.push({path:'/home/shops'})
                }
              }).catch(function (error) {
                console.log(error)
                vm.loginErr = true
                vm.errMessage = vm.$t('login.loginTip.fail')
                vm.requestings.logining = false
              })
            }else{
              vm.loginErr = true
              vm.errMessage = vm.$t('login.loginTip.fail')
              vm.requestings.logining = false
            }
          }).catch(function (err) {
            //console.log(err.response)
            vm.loginErr = true
            // var resData = err.response.data
            if(err.response && err.response.data) {
              var resData = err.response.data
              if(resData.message.indexOf('坏的凭证') !== -1 || resData.message.indexOf('Bad credentials') !== -1) {
                vm.errMessage = vm.$t('login.loginTip.passwordErr')
              } else if (resData.message.indexOf('null') !== -1) {
                vm.errMessage = vm.$t('login.loginTip.exist')
              } else if (resData.message.indexOf('activated') !== -1){
                vm.errMessage = vm.$t('login.loginTip.valid')
              }
            } else {
              vm.errMessage = vm.$t('login.loginTip.fail')
            }
            vm.requestings.logining = false
          })
        } else {
          //console.log('submit error!')
          return false
        }
      })
    },
    chooseSys: function(e){
      // console.log('sysType', e, this.sysForm.sysType)
    },
    sure: function(form){
      var vm = this
      this.$refs[form].validate((valid) => {
        if(valid){
          // vm.isLoginForm = true
          vm.requestings.sureSencing = true
          vm.axios({
            method: 'post',
            url: '/V1/sence/save?sence=' + vm.sysForm.sysType.value,
            headers:{
              'Authorization': 'Bearer ' + vm.token
            }
            // data: vm.sysForm.sysType.value
          }).then(function(res){
            // console.log(res)
            if(res.data.status == 200) {
              for(var i = 0; i < res.data.body.length; i++) {
                for(var j in vm.$proLabels[res.data.body[i].lang]) {
                  vm.$proLabels[res.data.body[i].lang][j] = res.data.body[i][j]
                  // vm.defaultLabelVal[vm.sysForm.sysType.value][i][j] = res.data.row[i][j]
                }
                // vm.labelEditForm[res.data.body[i].lang] = res.data.body[i]
              }
              // console.log('login proLabels', vm.$proLabels)
              // vm.$route.meta.isLogin = true
              authToken.storeUserInfo({token: vm.token})
              // if(vm.isRootRole){
              vm.$router.push({path:'/home/shops'})
              // }
            } else if(res.data.status == 10000900) {
              vm.chooseErrMsg = vm.$t('login.chooseSysTip.exist')
              vm.chooseErr = true
            } else if(res.data.status == 10000901) {
              vm.chooseErrMsg = vm.$t('login.chooseSysTip.choosed')
              vm.chooseErr = true              
            } else {
              vm.chooseErrMsg = vm.$t('login.chooseSysTip.operateFail')
              vm.chooseErr = true
            }
            vm.requestings.sureSencing = false
          }).catch(function(err){
            // console.log(err, err.response)
            if(err.response && err.response.status == 401){
              vm.$router.push('/')
              authToken.removeUserInfo()
            } else {
              vm.chooseErrMsg = vm.$t('login.chooseSysTip.operateFail')
              vm.chooseErr = true              
            }
            vm.requestings.sureSencing = false
          })
        } else {
          return false
        }
      })
    },
    editLabel: function(){
      // this.labelEditDialog = true
      // console.log('loginRefs', this.$refs)
      var vm = this
      // this.labelEditReset.en = false
      // this.labelEditReset.zh = false
      for(var i in this.labelEditReset) {
        this.labelEditReset[i] = false
      }
      this.senceEditReset = false
      this.$nextTick(function(){
        // this.labelEditReset.en = true
        // this.labelEditReset.zh = true
        for(var i in this.labelEditReset) {
          this.labelEditReset[i] = true
        }
        this.senceEditReset = true

        this.dialogTitle = this.$t('login.customLabel')
        this.senceEditForm.senceLang = []
        this.senceEditForm.sence = this.sysForm.sysType.label
        this.activeNames = ['sence']
        for(var i in this.labelEditForm) {
          for(var j = 0; j < this.labels.length; j++) {
            var prop = this.labels[j].prop
            this.$set(this.labelEditForm[i], prop, '')
          }
        }
        // this.operateType="addUserSure"
        // this.dialogIsForm=true
        // objOperate.resetObj(this.userForm)
        // this.userForm.active = this.$t('system.userTab.userAttr.validOpt')[0].value
        // console.log(this.sysForm.sysType)
        // if(this.sysForm.sysType.value) {
        //   this.senceEditForm.sence = this.sysForm.sysType.label
        //   for(var i in this.labels) {
        //     i === 'label1' ? this.labelEditForm.zh[i] = this.labelEditLabel[i].zh.value : this.labelEditForm.zh[i] = ''
        //     i === 'label1' ? this.labelEditForm.en[i] = this.labelEditLabel[i].en.value : this.labelEditForm.en[i] = ''
        //   }
        // } else {
        //   this.senceEditForm.sence = ''
          // for(var i in this.labels) {
          //   this.labelEditForm.zh[i] = this.labelEditLabel[i]['zh'].value
          //   this.labelEditForm.en[i] = this.labelEditLabel[i]['en'].value
          // }
        // }

        //默认场景值可以只在页面加载时获取一次就行
        this.labelEditLoading = true
        if(this.cancelToken){
          this.source.cancel()
        }
        this.source = this.axios.CancelToken.source();
        this.cancelToken = this.source.token;
        this.axios({
          method: 'get',
          url: '/V1/sence?sence=' + vm.sysForm.sysType.value,
          headers:{
            'Authorization': 'Bearer ' + vm.token
          },
          cancelToken:vm.cancelToken
        }).then(function(res){
          // console.log(res, res.data.body.length)
          for(var i = 0; i < res.data.body.length; i++) {
            var lang = res.data.body[i].lang
            for(var j in vm.labelEditForm[lang]) {
              vm.labelEditForm[lang][j] = res.data.body[i][j]
              // vm.defaultLabelVal[vm.sysForm.sysType.value][i][j] = res.data.row[i][j]
            }
            // vm.labelEditForm[res.data.body[i].lang] = res.data.body[i]
          }
          // console.log(vm.labelEditForm)
          vm.labelEditLoading = false
        }).catch(function(err){
          // console.log(err)
          // vm.labelEditLoading =false
          // vm.labelEditDialog = false
          if(!vm.axios.isCancel(err)){
            vm.labelEditLoading =false
            vm.labelEditDialog = false
            if(err.response && err.response.status == 401){
              vm.$router.push('/')
              authToken.removeUserInfo()
            } else {
              vm.operateMsg = vm.$t('login.labelEditTips.getLabelNameFail')
              vm.msg1Dialog = true   
            }
          }
        })

        this.labelEditDialog = true
      })
    },
    cancelDialog: function(){
      // console.log('cancelDialog')
      this.labelEditDialog = false
    },
    labelEditSure: function(){
      var vm = this

      var isValid = true
      this.$refs.senceEditForm.validate((valid) => {
        if(!valid) {
          isValid = false
          if(this.activeNames.indexOf('sence') === -1) {
            this.activeNames.push('sence')
          }
        }
      })

      for(var j = 0; j < this.senceEditForm.senceLang.length; j++) {
        this.$refs['labelEditForm' + vm.senceEditForm.senceLang[j]][0].validate((valid) => {
          if(!valid) {
            isValid = false
            if(this.activeNames.indexOf(vm.senceEditForm.senceLang[j]) === -1) {
              this.activeNames.push(vm.senceEditForm.senceLang[j])
            }
          }
        })
      }

      if(isValid) {
        // console.log(this.labelEditForm, this.senceEditForm)
        var datas = []
        // var langs = ['zh', 'en']
        for(var i = 0; i < vm.senceEditForm.senceLang.length; i++){
          var formData = {}
          for(var j in vm.labelEditForm[vm.senceEditForm.senceLang[i]]) {
            formData[j] = vm.labelEditForm[vm.senceEditForm.senceLang[i]][j]
          }
          formData['lang'] = vm.senceEditForm.senceLang[i]
          formData['sence'] = vm.sysForm.sysType.value
          datas.push(formData)
        }
        vm.requestings.postSencing = true
        this.axios({
          method: 'post',
          url: '/V1/sence',
          data: datas,
          headers:{
            'Authorization': 'Bearer ' + vm.token
          }
        }).then(function (res) {
          // console.log(res)
          vm.labelEditDialog = false
          if(res.data.status==200){
            vm.operateMsg = vm.$t('login.labelEditTips.success')
            // vm.getDatas()
          }else{
            vm.operateMsg = vm.$t('login.labelEditTips.fail')
          }
          // vm.dialogTitle = '提示'
          vm.msg1Dialog = true
          vm.requestings.postSencing = false
        }).catch(function (err) {
          //console.log(err)
          vm.labelEditDialog = false
          if(err.response && err.response.status == 401){
            vm.$router.push('/')
            authToken.removeUserInfo()
          } else {
            vm.operateMsg = vm.$t('login.labelEditTips.fail')
            // vm.dialogTitle = '提示'
            vm.msg1Dialog = true              
          }
          vm.requestings.postSencing = false
        })
      } else {
        // console.log('submit error')
        return false
      }
    },
    handleChange(val) {
      // console.log(val);
    },
    cancelMsg: function() {
      this.msg1Dialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  /* background: rgb(98,100,2356); */
  /* background: linear-gradient(to top right, rgb(93,88,238) , rgb(103,124,230)); */
  /* background: url(/static/images/background.png); */
  background: rgb(250,249,255);
  background-size: 100% 100%;
  /* min-height: 800px;
  min-width: 992px; */
  /* min-height: 900px; */
  position: relative;
  min-width: 320px;
  min-height: 650px;
}
.bg1v-icons {
    position: absolute;
    width: 100%;
    height: 100%;
    /* z-index: 0; */
    left: 0;
    top: 0;
}
#lg-img1{
  width: 9.3%;
  position: absolute;
  top: 0;
  left: 0;
}
#lg-img9{
  width: 4.5%;
  position: absolute;
  top: 0;
  right: 0;
}
#lg-img8{
  /* width: 2.9%; */
  width: 6.82%;
  position: absolute;
  top: 0;
  /* right: 8.8%; */
  right: 6.8%;
}
#lg-img24{
  /* width: 50.9%; */
  width: 58.2%;
  position: absolute;
  bottom: 0;
  left: 0;
}
#lg-img10{
  width: 2.7%;
  position: absolute;
  bottom: 2%;
  left: 3.3%;
}
#lg-img11{
  /* width: 2.2%; */
  width: 8.125%;
  position: absolute;
  /* bottom: 2%; */
  bottom: 0;
  /* right: 21.4%; */
  right: 16.4%;
}
#lg-img7{
  width: 14.9%;
  position: absolute;
  bottom: 0;
  right: 0;
}

.login-main{
    width: 88.125%;
    height: 79%;
    /* min-height: 741px; */
    /* margin: 0 auto; */
    /* background: #fff; */
    position: relative;
    z-index: 1;
    background: #fff;
    box-shadow: 4px 0 50px rgba(111,166,223,.3);
    border-radius: 7px;
    /* min-height: 770px; */
}
div#lg-col-1 {
    width: 55.2%;
    height: 100%;
    /* background: #fff;
    box-shadow: 4px 0 50px rgba(111,166,223,0.3);
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px; */
    position: relative;
}

.col1-bg1v-icons {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}

img#lg-img22 {
    width: 13%;
    position: absolute;
    top: 0;
    left: 0;
}

img#lg-img3 {
    width: 51.6%;
    position: absolute;
    left: 0;
    /* top: 27.7%; */
    top: 25.7%;
}

.col1-bg2v-icons {
    /* position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0; */
    position: absolute;
    width: 100%;
    height: 0;
    top: 50%;
    left: 0;
    padding-bottom: 82.4%;
    margin-top: -38%;
}

img#lg-img4 {
    width: 53.5%;
    position: absolute;
    /* top: 4.7%;
    right: 11.7%; */
    top: 1.8%;
    right: 13.5%;
}

/* .col1-bg3v-icons {
    position: absolute;
    width: 100%;
    height: 0;
    top: 0;
    left: 0;
    z-index: 4;
    padding-bottom: 65.1%;
} */

img#lg-bgl {
    width: 84.5%;
    /* height: 82%; */
    position: absolute;
    left: 4%;
    top: 12%;
}

/* .col1-line-icons {
    position: absolute;
    width: 100%;
    height: 0;
    top: 0;
    left: 0;
    padding-bottom: 65.1%;
} */

img#lg-img12 {
    width: 12.6%;
    position: absolute;
    /* top: 16.1%; */
    top: 14.1%;
    left: 28%;
}

img#lg-img14 {
    width: 11.35%;
    position: absolute;
    /* top: 27.8%; */
    top: 25.8%;
    left: 13.6%;
}

img#lg-img15 {
    width: 8.9%;
    position: absolute;
    left: 9.5%;
    /* top: 50%; */
    top: 48%;
}

img#lg-img17 {
    width: 9.7%;
    position: absolute;
    left: 19.8%;
    /* top: 71%; */
    top: 66.5%;
}

img#lg-img16 {
    width: 24.6%;
    position: absolute;
    /* left: 32.8%;
    top: 64.7%; */
    left: 32.8%;
    /* top: 62.7%; */
    top: 60.7%;
}

img#lg-img19 {
    width: 26.6%;
    position: absolute;
    /* left: 57%;
    top: 48%; */
    left: 56.5%;
    /* top: 46%; */
    top: 43%;
}

img#lg-img13 {
    width: 27.6%;
    position: absolute;
    left: 52.5%;
    /* top: 20.5%; */
    top: 17.5%;
}

img#lg-img18 {
    width: 25.3%;
    position: absolute;
    /* left: 23.6%;
    top: 29.9%; */
    /* left: 22.6%;
    top: 29%; */
    left: 23.6%;
    top: 27%;
}

img#lg-img20 {
    width: 54.5%;
    position: absolute;
    /* left: 30.4%;
    top: 47.4%; */
    left: 30.2%;
    /* top: 45.4%; */
    top: 43%;
}

img#lg-img21 {
    width: 10.5%;
    position: absolute;
    /* left: 24.8%;
    top: 82.2%; */
    left: 24.8%;
    /* top: 81.2%; */
    top: 79.2%;
}

div#lg-col-2 {
    width: 1.8%;
    height: 100%;
    background: url(/static/images/login/login_icon_25.png);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 140%;
    position: relative;
}

img#lg-img26 {
    position: absolute;
    bottom: 0;
    left: -84%;
    width: 130%;
}

img#lg-img27 {
    position: absolute;
    top: 2%;
    left: -15%;
    width: 130%;
}

.col2-bg1v-icons {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
}

div#lg-col-3 {
    width: 43%;
    height: 100%;
    position: relative;
}

img#lg-img23{
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20.9%;
}

.bgTop-icons {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    left: 0;
    top: 0;
}

img#lg-img5 {
    position: absolute;
    right: -6.7%;
    /* bottom: 17.5%;
    width: 19.3%; */
    bottom: 21.5%;
    width: 21.93%;
}

img#lg-img6 {
    position: absolute;
    /* bottom: -13.2%;
    width: 41%;
    right: 25%; */
    bottom: -13.2%;
    width: 46.5%;
    right: 24%;
}

.title {
  /* font-size: 42px;
  color: #fff;
  line-height: 62px; */
  font-size: 36px;
  color: #738cfa;
  /* margin-top: 4%; */
  margin-left: 6.5%;
  position: relative;
  z-index: 1;
  margin-top: -34.5%;
  top: 50%;
}
/* .login{
  margin: 0 27%;
}
.lg-logo{
  margin-top: 27%;
} */
.login-wrap {
    margin: 0 27%;
    position: relative;
    top: 50%;
    margin-top: -200px;
}
.login {
  /* margin-top: 35px; */
  margin-top: 25px;
  /* position: absolute;
  width: 100%; */
}
.input-item-wrap{
  margin-top: 45px;
  margin-bottom: 0px;
}
.input-item-wrap:first-child{
  margin-top: 0px;
}
.input-item-wrap>>> .el-form-item__label{
  font-size: 14px;
  color: #666;
}
.input-item{
  width: 100%;
}
.input-item-wrap>>> input{
  height: 55px;
  color: #666;
  border-color: rgb(203,213,221);
  font-size: 14px;
  line-height: 55px;
}
.input-item-wrap>>> input::-webkit-input-placeholder{
  color: #666 !important;
}
.input-item-wrap>>> input:-ms-input-placeholder{
  color: #666 !important;
}
.input-item-wrap>>> input::-moz-placeholder{
  color: #060606  !important;
}
.login-tips {
    font-size: 12px;
    color: #666;
    margin-top: 30px;
}
.close, .open, .clear{
  width: 26px;
  height: 26px;
  display: inline-block;
  position: relative;
  top: 14px;
  cursor: pointer;
}
.clear{
  background: url(/static/images/clear.png);
}
.close{
  background: url(/static/images/close_eye.png);
}
.open{
  background: url(/static/images/open_eye.png);
}
.submit{
  /* margin-top: 55px; */
  margin-top: 65px;
}
.submit button{
  background-color: rgb(56,105,251) !important;
  width: 100%;
  color: #fff !important;
  height: 55px;
  font-size: 18px;
  margin-bottom: 0;
}
.err{
  position: static;
  text-align: center;
  font-size: 14px;
}

/* .slide-fade-enter-active {
  transition: all .3s ease;
} */
.slide-fade-enter-active, .slide-fade-leave-active{
  transition: all 0.55s;
}
.slide-fade-enter{
  transform: translateX(46%);
  opacity: 0;
}
.slide-fade-leave-to{
  transform: translateX(-46%);
  opacity: 0;
}

#custom-label{
  margin: 0px;
}

#edit-label{
  padding: 0px;
  color: #58585b;
}
#edit-label:hover{
  color: #4071fb;
  text-decoration: underline;
}

.label-edit-dialog.custom-dialog>>> .label-input{
  display: inline-block;
}

/* .label-edit-dialog.custom-dialog>>> .el-dialog {
  min-width: 400px;
} */
.label-edit-dialog.custom-dialog>>> .el-dialog__body{
  padding:30px 10% 15px;
}
.label-edit-dialog.custom-dialog>>> .el-dialog__footer{
  padding:0px 10% 30px;
}

#label-edit-collapse>>> .el-collapse-item__header {
  font-size: 14px;
  color: #58585b;
}

#sence-lang>>> .el-checkbox{
  margin-left: 0;
}
#sence-lang>>> .el-checkbox__inner{
  width: 16px;
  height: 16px;
  border: 1px solid #58585b;
  border-radius: 3px;
  background: transparent;
}
#sence-lang>>> .el-checkbox__input.is-checked .el-checkbox__inner{
  border-color: #4071fb;
}
#sence-lang>>> .el-checkbox__inner::after{
  height: 9px;
  width: 4px;
  top: 1px;
  left: 4px;
  border: 2px solid #4071fb;
  border-left: 0;
  border-top: 0;
}

#sence-lang>>> .el-checkbox__label {
  font-size: 14px;
  color: #58585b;
}

@media screen and (max-width: 1892px){
  .label-edit-dialog.custom-dialog>>> .el-dialog{
    width:925px !important;
    margin-top:8VH !important;
  }
}
@media screen and (max-width:1344px){
  .label-edit-dialog.custom-dialog>>> .el-dialog{
    width:925px !important;
  }
  div#lg-col-1, div#lg-col-2{
    display: none;
  }
  div#lg-col-3{
    width: 100%;
  }
  .login-main{
    width: 60% !important;
    height: 79% !important;
  }
}
/* @media screen and (max-width:1220px){
  div#lg-col-1, div#lg-col-2{
    display: none;
  }
  div#lg-col-3{
    width: 100%;
  }
  .login-main{
    width: 60% !important;
    height: 79% !important;
  }
} */
/* @media screen and (max-width:1344px){
  .login-main{
    width: 66%;
  }
}
@media screen and (max-width:991px){
  .login-main{
    width: 50%;
  }
} */
@media screen and (max-width:1066px){
  .label-edit-dialog.custom-dialog>>> .el-dialog{
    width:925px !important;
  }
}
@media screen and (max-width:991px){
  /* div#lg-col-1, div#lg-col-2{
    display: none;
  }
  div#lg-col-3{
    width: 100%;
  }
  .login-main{
    width: 88.125% !important;
    height: 79% !important;
  } */
  .label-edit-dialog.custom-dialog>>> .el-dialog{
    width:435px !important;
  }
}

/* @media screen and (max-width: 820px){
  .label-edit-dialog >>> .el-dialog{
    width:400px !important;
  }
} */

@media screen and (max-width:796px){
  .label-edit-dialog.custom-dialog>>> .el-dialog{
    width:435px !important;
  }
  .login-main{
    width: 88.125% !important;
  }
}
@media screen and (max-width:496px){
  .label-edit-dialog.custom-dialog>>> .el-dialog{
    width:435px !important;
  }
  .label-edit-dialog.custom-dialog>>> .el-dialog__body{
    padding: 30px 5% 15px;
  }
  .label-edit-dialog.custom-dialog>>> .el-dialog__footer{
    padding: 0px 5% 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/login.vue